import React, { Component } from "react";
import withStyles from "@material-ui/styles/withStyles";
import { Link, withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import MenuIcon from "@material-ui/icons/Menu";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import { Container, Link as MaterialLink } from "@material-ui/core";
import Menu from "./Menu";

const logoGarnet = require("../images/logo-maqui.png");
const logoMaconline = require("../images/gmo_logoz.png");

const styles = theme => ({
  appBar: {
    position: "relative",
    boxShadow: "none",
    backgroundColor: "#2D2D2D"
  },
  flexAlignCenter: {
    display: "flex",
    alignItems: "center"
  },
  flexTopbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: 'wrap',
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0rem",
      paddingRight: "0rem"
    }
  },
  link: {
    textDecoration: "none",
    color: "inherit"
  },
  containerTopbar: {
    padding: "10px 5rem",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0rem",
      paddingRight: "0rem"
    }
  },
  productLogo: {
    display: "inline-block",
    borderLeft: `1px solid ${theme.palette.grey["A100"]}`,
    marginLeft: 32,
    paddingLeft: 24,
    [theme.breakpoints.up("md")]: {
      paddingTop: "1.5em"
    }
  },
  tagline: {
    display: "inline-block",
    marginLeft: 10,
    [theme.breakpoints.up("md")]: {
      paddingTop: "0.8em"
    }
  },
  iconContainer: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block"
    }
  },
  iconButton: {
    float: "right"
  },
  tabContainer: {
    marginLeft: 32,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  tabItem: {
    paddingTop: 20,
    paddingBottom: 20,
    minWidth: "auto"
  },
  logoGarnet: {
    [theme.breakpoints.down("sm")]: {
      height: "32px"
    }
  },
  logoMaconline: {
    width: "140px",
    [theme.breakpoints.down("sm")]: {
      width: "100px"
    }
  }
});

class Topbar extends Component {
  state = {
    value: 0,
    menuDrawer: false
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  mobileMenuOpen = event => {
    this.setState({ menuDrawer: true });
  };

  mobileMenuClose = event => {
    this.setState({ menuDrawer: false });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  currentLogo = () => {
 
    if (this.props.currentPath == "opv") {
      return require("../images/logo_opv.png");
      
    }
    else if (this.props.currentPath == "econopticas") {
      return require("../images/logo_eco.png");
      
    }
    else {
      return require("../images/gmo_logoz.png");
      // return require("../images/logo_opv.png");
      
    }
  };
  
  currentMainColor = () => {
    if (this.props.currentPath == "virgin") {
      return "#EE0001";
      
    }
    else {
      return "#15669D";
    }
  };

  render() {
    const { classes } = this.props;
    const openInNewTab = (url) => {
      window.open(url, '_blank', 'noreferrer');
    };
    return (
      <AppBar position="absolute" color="default" className={classes.appBar}>
        <Toolbar>
          
            <Grid className={classes.containerTopbar} container spacing={10} alignItems="baseline">
              <Grid item xs={12} className={classes.flexTopbar}>
                <div className={classes.flexAlignCenter}>
                      <Link   onClick={() => openInNewTab('https://maquiseguros.cl')}  className={classes.link}>
                      <img className={classes.logoGarnet} src={logoGarnet} alt="garnet" />
                    </Link>
                </div>
                <div className={classes.flexAlignCenter}>
                  <img className={classes.logoMaconline} src={this.currentLogo()} alt="maconline seguros" />
                </div>
              </Grid>
            </Grid>
          
            
        </Toolbar>
      </AppBar>
    );
  }
}

export default withRouter(withStyles(styles)(Topbar));
